import stageBreakpoints from '../config/stage_breakpoints.json';

export const STAGE_BP_MOBILE_MAX = stageBreakpoints.mobileMax;
export const STAGE_BP_TABLET_MAX = stageBreakpoints.tabletMax;
export const STAGE_BP_DESKTOP_MIN = stageBreakpoints.desktopMin;
